import { render, staticRenderFns } from "./RejectOrderItem.vue?vue&type=template&id=08b71746&"
import script from "./RejectOrderItem.vue?vue&type=script&lang=js&"
export * from "./RejectOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports